import React from 'react';
import { ReactComponent as IconDelete } from '../../../assets/icons/IconDelete.svg';
import { Button } from '@mui/material';

interface DocumentPreviewProps {
  file?: { preview: string };
  handleDeleteDocument: () => void;
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({ file, handleDeleteDocument }) => (
  <div className="containerDocument">
    <img className="documentPicture" src={file?.preview} alt="pré visualização do documento" />
    <div className="contentDocument">
      <Button
        onClick={handleDeleteDocument}
        className="deletePicture"
        aria-label="Excluir documento">
        <IconDelete />
      </Button>
    </div>
  </div>
);

export default DocumentPreview;
